<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <v-card flat>
                    <v-card-text>
                        <v-form>
                            <v-row>
                                <v-col cols="12" md="8">
                                    <v-row>
                                        <v-col cols="12">
                                            <autocomplete title="name"
                                                          label="Select Assessmnet"
                                                          :items="authorizationRules"
                                                          :selected-items="authorizationRulesSelected"
                                                          :sub-title="['subtitle']"
                                                          :multipleItems="false"
                                                          @autocomplete-selected="updateSelectedItems($event)"
                                                          :error-messages="authorizationError"
                                                          error-count=1
                                                          :setFieldLock="lockFields"
                                            >
                                            </autocomplete>
                                        </v-col>
                                        <v-col cols="12" v-if="employeeGroupTypes.length > 0">
                                            <v-label class="text-right">Status</v-label>
                                            <v-radio-group v-model="authStatus" row class="justify-center">
                                                <v-radio v-for="(item, index) in statusList" :key="index"
                                                         :label="item.text"
                                                         :color="item.color"
                                                         :disabled="item.disabled"
                                                         :value="item.status">

                                                </v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col cols="12" v-if="employeeGroupTypes.length > 0">
                                            <!--Employee hrs -->
                                            <h6>Number of hours per groups</h6>
                                            <v-row v-for="(item, index) in employeeGroupTypes"
                                            :key="item.id">
                                                <v-col col="8" md="10">
                                                    <v-text-field
                                                            :label="'Employee Category ' + (index+1) "
                                                            :placeholder="item.name"
                                                            readonly
                                                            outlined
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="4" md="2">
                                                    <v-text-field
                                                            label="Hrs"
                                                            v-model="item.hrs"
                                                            outlined
                                                            :disabled = "lockFields"
                                                            :error-messages="hrsError(index)"
                                                            error-count=1
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="text-right">
                                                    <h6>Total hrs: <br>
                                                        {{employeeGroupTypes
                                                        .map(item => item.hrs)
                                                        .reduce((acc, hrs) => acc+parseInt(hrs))}}
                                                    </h6>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-divider class="d-none d-md-flex mx-4 my-4" vertical inset></v-divider>
                                <v-col cols="12" md="3">
                                    <h5>Authorization File</h5>
                                    <doc-container  v-if="showDocContainer"
                                            :elevation="elevate? 4 : 0"
                                            @click="elevate = !elevate"
                                            :setDocumentRule="documentRule"
                                            :userId="path_id"
                                            :ref="documentRule.id"
                                            :setDocumentFile="documentFile"
                                            :canReplaceDoc="allowReplacement"
                                            :setFieldLock="lockFields"
                                            @document-changed = "docChange($event)"
                                    >

                                    </doc-container>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="6" sm="2">
                                    <v-btn color="default" text @click="close">
                                        Cancel
                                    </v-btn>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <v-btn color="primary"
                                           :loading="isSaving"
                                           :disabled="isSaving"
                                           @click="save">
                                        Save
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <dialog-alert :text="alertText"
                      :alert-type="alertType"
                      :open="openAlert"
                      @alert-closed="alertClosed($event)">
        </dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import {required} from 'vuelidate/lib/validators';
    import {AuthorizationRecord, EmbeddedClientAuthorization} from '../../../../shared/dtos/Dtos';
    import { FORM_STATUS } from '../../../../shared/enums/FormStatuses';
    const DialogAlert = () => import ('@/components/common/DialogAlert');
    import {formUnsavedMixin} from "../../../../shared/mixins/FormUnsaved";
    const Autocomplete = () => import("@/components/common/Autocomplete");
    const DocContainer = () => import('@/components/common/DocumentFilesContainer');
    import FileHandler from '@/fileHandler/Handler';
    import moment from 'moment';
    import {AUTHORIZATION_STATUS} from '@/shared/enums/EntitiesStatus';
    import {DOCUMENT_FILE_TYPE, DOCUMENT_FILE_ENTITY_TYPE} from "@/shared/enums/DocumentFile";

    export default {
        name: "authorizationRuleAssignmentForm",
        props:['path_id'],
        components:{
            DialogAlert, Autocomplete, DocContainer
        },
        mixins:[formUnsavedMixin],
        data(){
            return {
                isSaving: false,
                editedItem: {...AuthorizationRecord},
                authorizationRules: [],
                authorizationRulesSelected: {},
                employeeGroupTypes: [],
                elevate: false,
                documentRule:{},
                documentFile:{},
                authorizationRulesMap:{},
                client:{},
                authStatus: AUTHORIZATION_STATUS.CREATED.status,
                status:'',
                statusList: AUTHORIZATION_STATUS.USER_STATUS_ACTION(),
                authorizationRecordFormClient:{},
                allowReplacement: true,
                lockFields: false,
                showDocContainer: false,
            };
        },
        validations: {
            authorizationRulesSelected:{
                required
            },
            employeeGroupTypes: {
                $each:{
                    hrs:{
                        required
                    }
                }
            }
        },
        computed:{
            authorizationError(){
                const errors = [];
                if (!this.$v.authorizationRulesSelected.$dirty) {
                    return errors
                }

                !this.$v.authorizationRulesSelected.required && errors.push('Category is required.');
                return errors
            }
         },
        methods:{
            hrsError(index){
                const errors = [];
                if(!this.$v.employeeGroupTypes.$each.$dirty){
                    return errors;
                }

                !this.$v.employeeGroupTypes.$each[index].hrs.required && errors.push('Hrs are required.')
                return errors;
            },
            async initialize() {
                this.getAuthorizationRules();

                if(this.path_id)
                    await this.$store.dispatch('getClient', {id: this.path_id});

                this.client = this.$store.getters.getClient;
                if(this.client.id) {
                    this.editedItem.clientId = this.client.id;
                    //check for authorization record
                    if(this.client.authorizationRecord){
                        try{
                            let authorizationRecordLite = this.client.authorizationRecord;
                            await this.$store.dispatch('getAuthorizationRecord', {id: authorizationRecordLite.authorizationRecordId});
                            this.authorizationRecordFormClient = this.$store.getters.getAuthorizationRecord;
                            //check status if inactive we can only clone and create a new one from it
                            if(this.authorizationRecordFormClient.id){
                                if(this.authorizationRecordFormClient.status == AUTHORIZATION_STATUS.INACTIVE.status){
                                    //clone
                                    delete this.client.authorizationRecord;
                                }
                                else{
                                    //edit
                                    this.editedItem = {...this.authorizationRecordFormClient};
                                }

                                this.authorizationRulesSelected = this.authorizationRulesMap[this.authorizationRecordFormClient.authorizationRuleId];
                                return ;
                            }
                            //new record do nothing
                        }
                        catch (e) {
                            alertEventBus.setAlert({type:'error', msg: e.message});
                            this.$log.error('Error: ', e);
                            this.isSaving = false;
                            return ;
                        }
                    }
                }
                else{
                    //get out to client table
                    this.close();
                }
            },
            close(){
                this.resetValues();
                this.status = FORM_STATUS.CLOSE;
                this.$router.push({name: 'clientTable'});
            },
            resetValues(){
                this.$v.$reset();
                this.$store.commit('setClient', {});
            },
            async save(){
                let child = this.$refs[this.documentRule.id];
                if(child === undefined){
                    return ;
                }
                let hasErrors = await child.validate();

                this.$v.$touch();
                if(this.$v.$anyError || hasErrors)
                    return;

                this.isSaving = true;

                try {
                    /**
                     *  0- save document file if not have been save before, ie edit with document already upload
                     *  1- save authorization record
                     *  2- save client with authorization record
                     */
                    //uploading document
                    let isEdit = !!!!this.client.authorizationRecord &&
                        this.client.authorizationRecord.documentFileId != this.documentFile.file_id
                    let isNew = !!!this.client.authorizationRecord;

                    if(this.documentFile.hasOwnProperty('file') && (isNew || isEdit)) {
                        let metadata = {...this.documentFile.metadata};
                        metadata.issue_date = this.documentFile.issue_date;
                        if(this.documentFile.expiration_date !==''){
                            metadata.expiration_date = this.documentFile.expiration_date;
                        }

                        metadata.status = this.documentFile.status;
                        metadata.belong= this.client.id;
                        metadata.created_by= this.$store.getters.getUser.attributes.sub;
                        metadata.display_name= this.$store.getters.getUser.username;
                        metadata.document_type= DOCUMENT_FILE_TYPE.AUTHORIZATION;
                        metadata.entity_type= DOCUMENT_FILE_ENTITY_TYPE.AUTHORIZATION;

                        await FileHandler.createFile('Document', this.documentFile.file, metadata);
                        //add document file to authorization record
                        this.editedItem.documentFileId = this.documentFile.file_id;
                        this.editedItem.startDate = this.documentFile.issue_date;
                        if(this.documentFile.expiration_date === '') {
                            delete this.editedItem.endDate;
                            this.editedItem.timePeriod = 999999999;
                        }
                        else{
                            this.editedItem.endDate = this.documentFile.expiration_date;
                            this.editedItem.timePeriod = moment.duration(
                                moment(...this.editedItem.startDate).diff(moment(...this.editedItem.endDate))).asHours();
                        }
                        //add documentrule Id to authorization record
                        this.editedItem.documentRuleId = this.documentRule.id;
                    }

                    this.editedItem.employeeGroupTypeHrs = this.employeeGroupTypes;
                    this.editedItem.totalHrs.left = this.employeeGroupTypes
                            .map(item => item.hrs)
                            .reduce((acc, hrs) => acc+parseInt(hrs));

                    this.editedItem.status = this.authStatus;
                    await this.$store.dispatch('setAuthorizationRecord', this.editedItem);
                    let authRecord = this.$store.getters.getAuthorizationRecord;

                    //add authorization record to client object
                    let embeddedAuthorization = {...EmbeddedClientAuthorization};
                    embeddedAuthorization.authorizationRecordId= authRecord.id;
                    embeddedAuthorization.documentFileId= authRecord.documentFileId;
                    embeddedAuthorization.startDate= authRecord.startDate;
                    embeddedAuthorization.endDate= authRecord.endDate;
                    embeddedAuthorization.timePeriod= authRecord.timePeriod;
                    embeddedAuthorization.status= authRecord.status;

                    this.client.authorizationRecord = embeddedAuthorization;
                    this.client.authorizationRuleId = authRecord.authorizationRuleId;
                    await this.$store.dispatch('setClient',this.client);
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    this.$log.error('Error: ', e);
                    this.isSaving = false;
                    return ;
                }

                this.status = FORM_STATUS.SAVE;
                this.close();
            },
            async getAuthorizationRules(){
                this.authorizationRules = this.$store.getters.getAuthorizationRules;
                if(this.authorizationRules.length <= 0){
                    //going backend
                    try {
                        await this.$store.dispatch('getAuthorizationRules');
                        this.authorizationRules = this.$store.getters.getAuthorizationRules;
                    }
                    catch (e) {
                        //set alert
                        alertEventBus.setAlert({type:'error', msg: e.message});
                        return;
                    }
                }

                this.authorizationRules = this.authorizationRules.map((item) => {
                    let groups = item.employeeGroupTypes;
                    item.subtitle = null;
                    for(let key in groups){
                        let line = item.subtitle == null? '': item.subtitle + ' | ';
                        item.subtitle = line +  groups[key].name;
                    }
                    this.authorizationRulesMap[item.id] = item;
                    return item;
                });
            },
            async updateSelectedItems(data){
                if(!!!data){
                    return;
                }

                if(!data.id){
                    delete this.editedItem.authorizationRuleId;
                    this.employeeGroupTypes=[];
                    this.documentFile = {};
                    this.documentRule = {};
                    return;
                }
                this.editedItem.authorizationName = data.name;
                this.editedItem.authorizationRuleId = data.id;
                this.authorizationRulesSelected = data;

                if(this.client.authorizationRecord){
                    this.authStatus = this.authorizationRecordFormClient.status;
                    let found = this.statusList.filter( item => item.status === this.authStatus);
                    if(found.length > 0){
                        //you can not go back to previous status
                        for (let item of this.statusList){
                            if (item.status !== this.authStatus){
                                item.disabled = true;
                                continue;
                            }
                            break;
                        }
                    }
                    else{
                        //the status is not in the one allow by user to change just show this one
                        this.statusList = [AUTHORIZATION_STATUS[this.authStatus]];
                    }

                    try{
                        let documentRuleId = this.authorizationRecordFormClient.documentRuleId;
                        //get documentRule
                        await this.$store.dispatch('getDocumentRule', {id: documentRuleId});
                        this.documentRule = this.$store.getters.getDocumentRule;

                        let documentFileId = this.authorizationRecordFormClient.documentFileId;
                        //get documentFile
                        await this.$store.dispatch('getDocumentFile', {id: documentFileId});
                        this.documentFile = this.$store.getters.getDocumentFile;

                        if(!this.documentFile.id){
                            throw {message: 'Document File not found for '+ documentFileId};
                        }
                    }
                    catch (e) {
                        alertEventBus.setAlert({type:'error', msg: e.message});
                    }

                    this.documentFile.file_id = this.documentFile.id;
                    this.documentFile.issue_date = moment(this.documentFile.systemCreatedDateTime).format('YYYY-MM-DD');
                    this.employeeGroupTypes = [...this.authorizationRecordFormClient.employeeGroupTypeHrs];

                    //check is we need to lock fields on the form
                    for(let item of AUTHORIZATION_STATUS.USER_STATUS_NOT_ALLOW_TO_MODIFY_FORM()){
                        if (item.status === this.authStatus){
                            this.lockFields = true;
                            // show note about, unable to modified authorization since it is in one of this status,
                            // please create a new authorization record form clone or new action.
                            alertEventBus.setAlert({type:'warning', msg: "Unable to modified authorization " +
                                    "since it is on status: "+ item.text});
                            break;
                        }
                    }
                    this.showDocContainer = true;
                    return;
                }

                try{
                    if(this.authorizationRecordFormClient.status == AUTHORIZATION_STATUS.INACTIVE.status){
                        this.employeeGroupTypes = [...this.authorizationRecordFormClient.employeeGroupTypeHrs]
                    }
                    else{
                        // new Authorization record
                        this.employeeGroupTypes = [...data.employeeGroupTypes];
                    }
                    //get documentRule
                    await this.$store.dispatch('getDocumentRule', {id: data.documentRuleId});
                    this.documentRule = this.$store.getters.getDocumentRule;
                    this.documentFile = {};
                    this.showDocContainer = true;

                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                }
            },
            docChange(documentFile){
                this.$log.debug(documentFile);
                this.documentFile = {...documentFile};
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>